(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-creations"] && !Shopify.designMode) return;
  try {
    
if (!window.immagineCreationsSocialLinks) {
  window.immagineCreationsSocialLinks = true;
  window.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-creations-social]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (window.Shopify?.designMode) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.open(link.href, '_blank', 'noopener,noreferrer');
    }
  }, true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
    document.querySelectorAll('.newborn-menu').forEach(menu => {
      const toggle = menu.querySelector('.newborn-menu__toggle');
      let timer;
      const setOpen = value => { menu.classList.toggle('is-open', value); toggle.setAttribute('aria-expanded', String(value)); };
      menu.addEventListener('mouseenter', () => { if (hover.matches) { clearTimeout(timer); setOpen(true); } });
      menu.addEventListener('mouseleave', () => { if (hover.matches) timer = setTimeout(() => setOpen(false), 180); });
      toggle.addEventListener('click', () => setOpen(!menu.classList.contains('is-open')));
      menu.addEventListener('focusout', event => { if (!menu.contains(event.relatedTarget)) setOpen(false); });
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { setOpen(false); toggle.focus(); } });
      document.addEventListener('click', event => { if (!menu.contains(event.target)) setOpen(false); });
    });
    const closeTimers = new WeakMap();
    const closeOthers = (keep) => document.querySelectorAll('.mega-menu[open]').forEach(menu => {
      if (menu !== keep) menu.open = false;
    });
    document.addEventListener('mouseover', event => {
      if (!hover.matches || event.sourceCapabilities?.firesTouchEvents) return;
      const menu = event.target.closest('.mega-menu');
      if (menu && !menu.contains(event.relatedTarget)) {
        clearTimeout(closeTimers.get(menu));
        closeOthers(menu);
        menu.open = true;
      }
    });
    document.addEventListener('mouseout', event => {
      if (!hover.matches || event.sourceCapabilities?.firesTouchEvents) return;
      const menu = event.target.closest('.mega-menu');
      if (menu && !menu.contains(event.relatedTarget)) {
        closeTimers.set(menu, setTimeout(() => {
          if (!menu.matches(':hover') && !menu.contains(document.activeElement)) menu.open = false;
        }, 180));
      }
    });
    document.addEventListener('click', event => {
      const menu = event.target.closest('.mega-menu');
      closeOthers(menu);
      if (menu && event.target.closest('summary') && hover.matches && event.pointerType === 'mouse' && menu.open) event.preventDefault();
      if (menu && event.target.closest('a')) menu.open = false;
    });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const menu = document.querySelector('.mega-menu[open]');
      if (menu) {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
    document.addEventListener('focusout', event => {
      const menu = event.target.closest('.mega-menu');
      if (menu && !menu.contains(event.relatedTarget)) menu.open = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-change]');
    if (!button) return;
    const input = button.closest('.qty').querySelector('input');
    if (button.dataset.quantityChange === '1') input.stepUp(); else input.stepDown();
    input.form.requestSubmit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    const thumb = event.target.closest('[data-gallery-image]');
    if (!thumb) return;
    const image = thumb.closest('.product-section').querySelector('[data-main-image] img');
    if (!image) return;
    event.preventDefault();
    image.src = thumb.dataset.galleryImage;
    image.removeAttribute('srcset');
    image.alt = thumb.querySelector('img').alt;
    thumb.parentElement.querySelectorAll('.gallery__thumb').forEach(item => item.classList.toggle('is-active', item === thumb));
  });

  } catch(e) { console.error(e); }
})();
})();
